import React, { SetStateAction, useRef, useState } from "react";
import { Textarea } from "@components/common/textarea";
import { Card } from "@components/common/card";
import { ArrowUpCircleIcon, PlusCircleIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/common/tooltip";
import axios from "axios";
import { parseCookies } from "nookies";
import { ACCESS_TOKEN } from "@pma/utils/constants";
import { toast } from "@pma/hooks/use-toast";
import useTranslator from "@pma/hooks/use-translator";
import { useAuth } from "@pma/stores/auth-store";
import { GetAIURL } from "@pma/utils/helpers";
import { Button } from "@components/common/button";
interface QueryProps {
  setData: React.Dispatch<SetStateAction<any[] | []>>;
}
const AddNewQuery: React.FC<QueryProps> = ({ setData }) => {
  const { translate } = useTranslator();
  const accessToken = parseCookies()[ACCESS_TOKEN];
  const [text, setText] = useState<string>();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const { authConfig } = useAuth();
  const orgId = authConfig?.last_organization_id;
  const userId = authConfig?.id;
  const [isReasoning, setisReasoning] = React.useState(false);

  React.useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height
    }
  }, [text]);

  // TO DO: Change this to react - query
  const ask = () => {
    if (text) {
      setisReasoning(true);
      axios
        .post(GetAIURL("/agent/message/"), {
          query: text,
          token: accessToken,
          extra_params: {
            organization_user_id: orgId,
            owner_id: userId,
          },
        })
        .then((res) => {
          const newEntry = {
            user: text,
            ai: {
              answer: res.data,
            },
          };

          setData((prevData) => [...prevData, newEntry]);
          setisReasoning(false);
          setText("");
        })
        .catch((err) => {
        });
    } else {
      toast({
        title: translate("Error"),
        description: translate("Message cannot be empty"),
        variant: "error",
      });
    }
  };

  return (
    <Card className='rounded-2xl'>
      <Textarea
        ref={textareaRef}
        placeholder={translate("Ask your ai assistant") + "..."}
        value={text}
        onChange={(e) => setText(e.target.value)}
        className='max-h-[300px] min-h-[100px] resize-none overflow-hidden rounded-2xl'
      />
      <div className='flex items-center justify-between p-3' dir='ltr'>
        <Tooltip>
          <TooltipTrigger asChild>
            <PlusCircleIcon color='blue' />
          </TooltipTrigger>
          <TooltipContent side="top">{translate("Add file from local drive")}</TooltipContent>
        </Tooltip>
        {isReasoning && (
          <span className='animate-gradient bg-gradient-to-r from-gray-400 to-white bg-clip-text font-semibold text-transparent'>
            {translate("Reasoning")}...
          </span>
        )}

        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant={"ghost"} disabled={isReasoning || !text} onClick={ask}>
              <ArrowUpCircleIcon color='blue' />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{translate("Send")}</TooltipContent>
        </Tooltip>
      </div>
    </Card>
  );
};

export default AddNewQuery;
